import store from "@/store";
import { ComponentMutation } from "@/framework/store/component/types";
import { SUPPORTED_LANGUAGES } from "@/framework/constants/trans";
import { value } from "vue-function-api";

export const setEnableKtznLang = (to: any) => {
  let use_kzn_lang = to.query.enable_ktzn_lang;
  if (use_kzn_lang == "1") {
    store.commit(ComponentMutation.SET_IS_ENABLE_KTZN_LANG, true);
  } else if (use_kzn_lang == "0") {
    store.commit(ComponentMutation.SET_IS_ENABLE_KTZN_LANG, false);
  }
};

export const getLanguageSelections = () => {
  return store.getters.isEnableKtznLang
    ? value(SUPPORTED_LANGUAGES)
    : value(
        SUPPORTED_LANGUAGES.filter((l) => {
          return l != "kzn";
        })
      );
};
